import { ChangeEvent, FocusEvent, useState } from "react";
import clsx from "clsx";

// MUI
import { GridRenderEditCellParams, useGridApiContext } from "@mui/x-data-grid-premium";
import { FormControl, TextField, TextFieldProps } from "@mui/material";

export function BasicTextEditCell(
	props: Readonly<GridRenderEditCellParams & { inputProps?: TextFieldProps & { acceptsEmptyValues?: boolean } }>
) {
	const { id, field, value, formattedValue, error, inputProps } = props;
	const apiRef = useGridApiContext();
	const [inputText, setInputText] = useState(value ?? formattedValue ?? "");

	const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
		const val = event.target.value;
		setInputText(val);
		await apiRef.current.setEditCellValue({ id, field, value: val, debounceMs: 200 });
	};

	const handleOnBlur = async (params: FocusEvent<HTMLInputElement>) => {
		await apiRef.current.setEditCellValue({ id, field, value: inputText, debounceMs: 200 });
		if (apiRef.current.state.editRows[id]) {
			apiRef.current.state.editRows[id][field].isDirty = false;
		}
		inputProps?.onBlur?.(params);
	};

	const handleOnFocus = (params: FocusEvent<HTMLInputElement>) => {
		apiRef.current.state.editRows[id][field].isDirty = true;
		inputProps?.onFocus?.(params);
	};

	const isValid = !error && (inputProps?.acceptsEmptyValues ? true : Boolean(inputText));

	return (
		<FormControl className="w-full">
			<TextField
				value={inputText}
				onChange={handleChange}
				className={clsx("relative top-[5px]", {
					"[&_input]:m-0 [&_input]:py-0 [&_input]:px-[10px]": true,
					"[&_input]:h-[21px] [&_input]:relative [&_input]:top-[-2px]": true,
					"[&_input]:font-sans [&_input]:text-[14px]": true,
					"[&_input]:text-[color:--text-color]": isValid,
					"[&_input]:text-[color:--text-alert-color]": !isValid,
				})}
				error={!isValid}
				placeholder={inputProps?.placeholder ?? "Enter value"}
				onBlur={handleOnBlur}
				onFocus={handleOnFocus}
				autoFocus={inputProps?.autoFocus ?? false}
			></TextField>
		</FormControl>
	);
}
